import { create as createStore } from 'zustand';

interface IStore {
  data: TQuizModalData;
  setData: (data: TQuizModalData) => void;
}

type TQuizModalData = {
  courseId: string;
  sectionIds?: string[];
} | null;

export const useCreateQuizModalStore = createStore<IStore>(set => ({
  data: null,
  setData: (data: TQuizModalData) => set(state => ({ ...state, data }))
}));
